import type { LoadingManager, MeshPhysicalMaterial, WebGLRenderer } from '@seddi/three';
import log from 'loglevel';

import { adapt } from './logoAdapter';
import type { LogoDesc } from './logoTypes';
import { load } from './materialLoader';
import { ResourceManager } from './resourceManager';

/**
 * Logo resources context.
 */
export class LogosContext extends ResourceManager<MeshPhysicalMaterial> {
  readonly manager: LoadingManager;
  readonly renderer: WebGLRenderer;

  constructor(manager: LoadingManager, renderer: WebGLRenderer) {
    super();
    this.manager = manager;
    this.renderer = renderer;
  }

  /**
   * Load logo.
   * @param desc - Descriptor.
   */
  async loadAsync(desc: LogoDesc): Promise<MeshPhysicalMaterial | undefined> {
    if (this.find(desc.id)) {
      log.warn(`LogosContext.loadAsync: ${desc.id} is not new.`);
      return undefined;
    }

    const item = this.create(desc.id);
    item.status = 'loading';

    const materialDesc = adapt(desc);
    const value = await load(materialDesc, this.manager, this.renderer);
    item.status = 'ready';
    item.value = value;

    if (this.onLoad) {
      this.onLoad(desc.id, 'Logo');
    }

    return value;
  }
}
